export enum ContractingEventsEnum {
  Src = 'src',
  CreditAnalysis = 'creditAnalysis',
  ContractSignature = 'contractSignature',
  preDataSysContractSignature = 'preDataSysContractSignature',
}

export enum SellerRoleEnum {
  Manager = 'MANAGER',
  AssistantManager = 'ASSISTANT_MANAGER',
  Seller = 'SELLER',
}
